export interface TeamTheme {
   color: string;
   image: string;
}

const TEAM_THEMES: Record<string, TeamTheme> = {
   Crocodile: {
      color: '#8de35d',
      image: '/images/swamp/teams/Crocodile.png',
   },
   Dragonfly: {
      color: '#e82337',
      image: '/images/swamp/teams/Dragonfly.png',
   },
   Turtle: {
      color: '#4c89ee',
      image: '/images/swamp/teams/Turtle.png',
   },
};

const FALLBACK_THEME: TeamTheme = {
   color: '#c8d4dc',
   image: '',
};

export function getTeamTheme(teamName: string): TeamTheme {
   return TEAM_THEMES[teamName] ?? FALLBACK_THEME;
}

export function teamImageSrc(teamName: string): string {
   const base = process.env.PUBLIC_URL || '';
   const image = getTeamTheme(teamName).image;
   return image ? `${base}${image}` : '';
}
